import constants from '../Constants';
const {
  GET_USERS,
  USERS_LOADING,
  ADD_USER,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_FAIL,
  DELETE_USER,
  RESET_USERS_ALERT,
  SEND_DETAILS,
  LOGOUT
} = constants;

const INIT_STATE = {
  users:{},
  usersMeta:{ lastPage: false, total: false, currentPage: 1, perPage: 20 },
  usersLoading: true,
  alert: { add: false, edit: false, delete: false, get: false, send: false },
  query: {},
};

const UserReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS:
      const { data, query } = action.payload;
      const { entities, result } = data; 
      return { 
            ...state, 
            users: entities.users, 
            usersMeta: {
                lastPage: result.last_page,
                total: result.total,
                currentPage: result.current_page,
                perPage: result.per_page,
                data: result.data,
            },
            usersLoading: false,
            query: query,
        };

    case USERS_LOADING:
        return {
            ...state, usersLoading: true,
        };

    case DELETE_USER:

        const { usersMeta, usersMeta: { data: metaData } } = state;

        const { [action.payload.toString()]: removed, ...rest } = state.users;
        
        metaData.splice(metaData.indexOf(action.payload), 1);
        
        const newMeta = { ...usersMeta, data: metaData };
        
        return { ...state, users: rest, usersMeta: newMeta, alert: INIT_STATE.alert };
    
    case ADD_USER:

        return {
            ...INIT_STATE,
            alert: { ...INIT_STATE.alert, add: { type: "success", message: "User added successfully." }},
        };
    
    case ADD_USER_FAIL:
        return {
            ...state,
            alert: { ...INIT_STATE.alert, add: { type: "warning", message: action.payload }},
        };

    case UPDATE_USER:
        const users = {...state.users,[action.payload.id]: action.payload};
        return {...state, users,  alert: { ...INIT_STATE.alert, edit: { type: "success", message: "User updated successfully." }}};

    case UPDATE_USER_FAIL:
        return {
            ...state,
            alert: { ...INIT_STATE.alert, edit: { type: "warning", message: action.payload }},
        };

    case RESET_USERS_ALERT: 
        return {
            ...state,
            alert: INIT_STATE.alert,
        };

    case SEND_DETAILS:
        return {
            ...state,
            alert: {...INIT_STATE.alert, send: { type: 'success', message: 'Details sent successfully!'} }
        };
    
    case LOGOUT:
        return INIT_STATE;

    default:
        return state;

    }
}

export default UserReducer;


// WEBPACK FOOTER //
// ./src/Reducers/UserReducer.js